export default __webpack_public_path__ + "static/media/file.f97ae170.svg";